import { render, staticRenderFns } from "./ConfigExAndImport.vue?vue&type=template&id=432c57a7&"
import script from "./ConfigExAndImport.vue?vue&type=script&lang=js&"
export * from "./ConfigExAndImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports